angular.module('cerego.v3Registration').factory('V3FreeTrialresource', [
  '$resource',
  ($resource: ng.resource.IResourceService) => {
    return $resource(
      '',
      {},
      {
        create: {
          method: 'POST',
          isArray: false,
          url: APIRoutes.v3_my_partners_path()
        }
      }
    );
  }
]);
